export default "__VITE_ASSET__HCagQow1__"